<template>
  <span style="text-align: end;">
    {{ sumColumn() }}
  </span>
</template>

<script>
import {
  formatCurrencyFraction2,
  sumColumnValueByListAndColumn,
} from '../../utils';

export default {
  props: {
    dataList: {
      type: Array,
      default: [],
      required: true,
    },
    property: {
      type: String,
      default: '',
      required: true,
    },
  },
  methods: {
    sumColumn() {
      const sum = sumColumnValueByListAndColumn(this.property, this.dataList);
      return formatCurrencyFraction2(sum, 0);
    },
  },
};
</script>
